<template>
    <template v-if="isMoreButton">
        <button
            type="button"
            v-bind:class="buttonClass"
            v-bind:disabled="isInactive"
            v-on:click="handleClick"
        >
            <span class="btn--text">
                <slot></slot>
            </span>
        </button>
    </template>
    <template v-else>
        <button
            type="button"
            v-bind:class="buttonClass"
            v-bind:disabled="isInactive"
            v-on:click="handleClick"
        >
        <slot></slot>
    </button>
    </template>
</template>
<script>
export default {
    name: "IthButton",

    // NB deliberately left false. There is no v-bind="$attrs" below, which means class,
    // style and stray attributes passed by callers are dropped. Several call sites do pass
    // a class expecting it to apply; turning inheritance on would suddenly start applying
    // those and change how those screens look. Rendering is driven solely by buttonClass.
    inheritAttrs: false,

    emits: ['buttonClick'],

    props: {
        // NB this is the *visual* variant ("primary" / "more" / "morecompact" / "none"),
        // not the HTML button type. The rendered element is always type="button"; these
        // buttons have never submitted a form natively and callers must not rely on it.
        type: {
            type: String,
            required: false,
            default: "primary"
        },

        isDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            clicked: false, // Shows loading animation when true
        };
    },

    computed: {
        typeNormalized() {
            return this.type.toLowerCase();
        },

        isMoreButton() {
            return (this.typeNormalized === "more" || this.typeNormalized === "morecompact");
        },

        // True when the button must not respond: explicitly disabled by the caller, styled
        // as a disabled variant, or already mid-flight from a previous click.
        isInactive() {
            return this.isDisabled || this.typeNormalized === "disabled" || this.clicked;
        },

        buttonClass() {
            // All types of buttons use the base btn class
            let classString = "btn";

            // Additional classes create the various types of buttons
            switch (this.typeNormalized) {
                case "primary":
                    classString += " btn-primary";
                    break;

                case "none":
                    // bare btn class for "non-special" buttons
                    break;

                // Default to primary if invalid type passed
                default:
                    classString += " btn-primary";
            }

            // Disabled buttons need the btn-disabled calss to display correctly
            if (this.isInactive) {
                classString += " btn-disabled";
            }

            // Start loading animation when button clicked
            if (this.clicked) {
                classString += " btn-loading";
            }

            return classString;
        }
    },

    methods: {
        handleClick() {
            // Guard as well as relying on the native disabled attribute: keeps the
            // component correct if it is ever rendered as a non-button element again.
            if (this.isInactive) {
                return;
            }
            this.clicked = true;
            this.$emit('buttonClick');
        },

        // Will be called by parent after validation failure
        stopLoading() {
            this.clicked = false;
        }

    }
}
</script>
